<template>
  <div>
    <HeaderComponent :menu-id="2"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="width: 1200px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>古钱币送评</span>收费标准</div>
        </div>
        <img src="@/assets/image/shoufei-guqian.jpg" alt="" style="width: 1200px; margin: 0 auto 60px auto;" />
        <div class="shoufei-title">估值提升</div>
        <div class="shoufei-4">
          <div style="width: 40%;"><span>服务名称</span>估值提升</div>
          <div><span>费用</span>基础服务费60元+估值提升部分*2%</div>
          <img src="@/assets/icon/sheng.png" alt="">
        </div>
        <!-- 附件 -->
        <ul class="fu-list">
          <li class="fu-item" v-for="item in fuList">{{ item }}</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      fuList: [
        '附1: 鉴定结果为伪品的钱币，按照真币估值正常收取评级费。',
        '附2: 鉴定为03有修补的钱币，如送评人有主观意识，并要求评03有修补，应以其问题币的价值进行评估收费。反之，送评人非主观意识的问题币送评，应以其正常钱币的价值进行估值正常收费，且不标注估值。',
        '附3: 鉴定结果为“无法判断"返还钱币，不收取鉴定费用。',
        '附4: 快评费用标准:快评服务费用为普通评级费用的2倍(可参与正常折扣)。5个工作日时效定义:指送评藏品签收后，小程序端5个工作日内出具评级结果。',
        '附5: 版别标注以专业著述为依据，未获得公认的版别和名称不标注。',
        '附6: 直径小于18.6mm或大于64.5mm，厚度超过6mm无法封装的古钱币，只出具评级标签或吊牌。',
        '附7: 低值批量采用水晶封闭盒进行封装，具体收费标准请联系客服。',
        '附8: 定制盒具体费用请联系客服。'
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.shoufei-title{
  font-size: 28px;
  font-weight: bold;
  color: #907B47;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.shoufei-4{
  display: flex;
  align-items: center;
  border: 1px solid #DDAF58;
  padding: 0 150px 0 50px;
  height: 80px;
  line-height: 78px;
  position: relative;
  div{
    font-size: 16px;
    span{
      font-size: 26px;
      font-weight: bold;
      padding-right: 30px;
    }
  }
  img{
    width: 120px;
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}
.fu-list{
  margin-top: 80px;
  margin-bottom: 50px;
}
.fu-item{
  letter-spacing: 1px;
  font-size: 16px;
  margin: 5px 0;
  line-height: 30px;
}
</style>